import * as yup from 'yup'

export const feedbackMentorshipSchema = yup.object({
	feedback: yup.string().trim(),
	reasonOther: yup
		.string()
		.trim()
		.when('$isOtherSelect', (isOtherSelect, schema) => {
			return isOtherSelect[0]
				? schema.required('* Preencha os campos obrigatórios.')
				: schema.optional()
		}),
})

export const scheduleMentorshipSchema = yup.object({
	goals: yup
		.string()
		.trim()
		.when('$isRescheduling', (isRescheduling, schema) => {
			return isRescheduling[0]
				? schema.optional()
				: schema.required('* Preencha os campos obrigatórios.')
		}),
})

export const cancelMentorshipSchema = yup.object({
	cancellationReasonType: yup.string().trim().required(),
	reason: yup
		.string()
		.trim()
		.when(
			'cancellationReasonType',
			(cancellationReasonType: Array<string>, schema) => {
				return cancellationReasonType[0] === 'OTHER'
					? schema.required('* Preencha os campos obrigatórios.')
					: schema.optional()
			}
		),
})
